import $ from "jquery";

$(document).on("click", ".tab", function (e) {
    const $this = $(this);
    const parent = $this.closest(".tabs");
    const ref = $this.attr("href") ?? "";

    if (ref.startsWith("#")) {
        console.log("not static");
        e.preventDefault();
    }

    parent.find(".tab").removeClass("tab-active");
    parent.find(".tab-content").removeClass("tab-content-shown");
    $this.addClass("tab-active");
    $(ref).addClass("tab-content-shown");
});
